module.exports = __webpack_public_path__ + "img/8.bc227203.jpg";